import script from "./PdOtpInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PdOtpInput.vue?vue&type=script&setup=true&lang=js"

import "./PdOtpInput.vue?vue&type=style&index=0&id=c524cf6c&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c524cf6c"]])

export default __exports__